import JobPayWall from "./JobPayWall";
export default JobPayWall;
